import $ from "jquery"
import "lightbox2"
import { isIE } from "./modules/browser"
import lang from "./modules/language"
import localstorageManager from "./modules/localstorage"
import { addCopyTextListener } from './modules/copytext'

"use strict";

// required by lightbox2

$.ajaxSetup({
    cache: true
});

/**
 * get script once and return promise
 *
 * @param url string
 * @return Deferred
 * @deprecated import should be used to load dependencies
 */
$.getScriptOnce = (url) => {
    var deferres = $.getScriptOnce.deferres;
    if (url in deferres) {
        return deferres[url];
    }
    return deferres[url] = $.getScript(url);
};
$.getScriptOnce.deferres = [];

// js stuff
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };
}


/**
 * scrolls the page to the top of the given jQuery selector
 * @param selector
 * @param callback
 */
function scrollTo(selector, callback) {
    if (selector == 0) return;
    $('body,html').animate({
        scrollTop: selector.offset().top
    }, 500, function () {
        if (callback && typeof (callback) === "function") {
            callback();
        }
    });
}


// meteoblue stuff
window.mb = window.mb || {};
window.mb.settings = window.mb.settings || {};
window.mb.settings.cdnServer = window.mb.settings.cdnServer || '';
window.mb.settings.mobilewidth = 600;

/**
 * Load google maps api and call callback
 * @deprecated import should be used to load dependencies
 */
window.mb.loadGoogleMaps = function () {
    var l = window.mb.settings.lang || 'en';
    return $.getScriptOnce("//maps.googleapis.com/maps/api/js?key=AIzaSyB3JPhvySdlda2u4FoVMWKf7IfEO_scL4o&v=3&language=" + l);
};

/**
 * Load leaflet
 * @deprecated import should be used to load dependencies
 */
window.mb.loadLeaflet = function () {
    if ($('#leaflettcss').length == 0) {
        $('<link/>', {
            rel: 'stylesheet',
            type: 'text/css',
            id: 'leaflettcss',
            href: "https://static.meteoblue.com/cdn/leaflet/v1.6.0/leaflet.css"
        }).appendTo('head');
    }
    // noinspection TypeScriptUnresolvedFunction
    return $.getScriptOnce("https://static.meteoblue.com/cdn/leaflet/v1.6.0/leaflet.js");
};

/**
 * Load custom leaflet, containing some leaflet plugins, which are required by old webmap interface
 * @deprecated remove as soon as old webmaps are removed from website. modifying library code is very bad practice. 
 */
window.mb.loadCustomLeaflet = function () {
    if ($('#leaflettcss').length == 0) {
        $('<link/>', {
            rel: 'stylesheet',
            type: 'text/css',
            id: 'leaflettcss',
            href: window.mb.settings.cdnServer + '/website/leaflet-custom/leaflet.css'
        }).appendTo('head');
    }
    return $.getScriptOnce(window.mb.settings.cdnServer + '/website/leaflet-custom/scripts.' + window.mb.settings.rev + '/leaflet.js');
};

/**
 * Load leaflet map player plugin
 */
window.mb.loadLeafletMapPlayer = function () {
    return $.getScriptOnce("https://static.meteoblue.com/lib/leaflet-map-player/v1.4.2/leaflet-map-player.js");
};

/**
 * Load mapbox gl js
 * @deprecated import should be used to load dependencies
 */
window.mb.loadMapboxGlJs = function () {
    if ($('#mapboxgljscss').length == 0) {
        $('<link/>', {
            rel: 'stylesheet',
            type: 'text/css',
            id: 'mapboxgljscss',
            href: "https://static.meteoblue.com/cdn/mapbox-gl-js/v1.11.1/mapbox-gl.css"
        }).appendTo('head');
    }
    return $.getScriptOnce("https://static.meteoblue.com/cdn/mapbox-gl-js/v1.11.1/mapbox-gl.js");
};

/**
 * get window with in px
 * @returns {Number|number}
 */
window.mb.windowWidth = function () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

// fallback to point+ promo for ads
window.mb.advertising = window.mb.advertising || {};
window.mb.advertising.fallback = function () {
    $('.adsbygoogle').each(function () {
        var _this = $(this);

        var _promo = $('<div/>').addClass(_this.attr('class').replace('adsbygoogle', ''));
        _promo.append($('<iframe/>').attr({
            src: '/' + window.mb.settings.lang + '/weather/index/pointplus',
            title: 'Point plus replacement',
            sandbox: 'allow-top-navigation allow-top-navigation-by-user-activation'
        }).css({
            width: '100%',
            height: '100%'
        }));
        _this.replaceWith(_promo);
    });
};



// jQuery stuff

/**
 * inline edit, see favourite.volt for required markup
 */
$.fn.inlineEdit = function () {
    var selector = $(this).selector;

    return $.each(this, function (key, element) {
        var jForm = $(element).find('form');

        // open form
        $(element).find('.edit').on("click",function () {
            $(selector).find('form').css('display', 'none');
            var jForm = $(element).find('form');
            jForm.css('display', 'flex');
            jForm.find(':text').first().trigger("focus");
        });

        // close form
        jForm.find('.cross').on("click",function () {
            $(element).find('form').css('display', 'none');
        });
    });
};

// on visible
var onVisibleQueue = [];
$.fn.onVisible = function () {
    var callback = arguments[0];
    $(this).each(function () {
        onVisibleQueue.push({ element: this, callback: callback || {} });
    });
};

/**
 * creates an overlay
 * @param callback
 * @param options
 * @returns {{toggle: toggle}}
 */
$.fn.overlay = function (callback, options) {
    var defaults = {
        cssClass: 'overlay_dark',
        divID: 'overlay_close',
        zindex: 993
    };
    var opts = $.extend(defaults, options);
    var _this = $(this);
    var animationTime = 200; // ms


    function open() {
        var overlay = $('#' + opts.divID);
        if (0 < overlay.length) {
            overlay.off();
        } else {
            overlay = $('<div/>', { 'id': opts.divID, 'class': opts.cssClass, 'style': 'z-index: ' + opts.zindex });
            overlay.appendTo(_this);
        }

        overlay.on("click",function () {
            if ("function" === typeof callback) {
                callback.apply();
            }
        });

        overlay.fadeIn({ duration: animationTime });
    }

    function close() {
        var _overlay = $('#' + opts.divID);
        _overlay.fadeOut(animationTime, function () {
            _overlay.remove();
        });
    }

    function toggle() {
        var _overlay = $('#' + opts.divID);
        if (0 < _overlay.length) {
            close();
        } else {
            open();
        }
    }

    return {
        open: open,
        close: close,
        toggle: toggle
    }
};

// toggles classes on click
$.fn.menu = function (options) {
    var defaults = {
        toggleable: 'extendable',
        toggleselector: 'extend',
        followlink: false,
        active: true
    };
    var opts = $.extend(defaults, options);

    $(this.find(' > .' + opts.toggleable + ' > a')).on("click",function () {
        if (opts.active) {
            var isActive = $(this).parent().hasClass(opts.toggleselector);
            $('.' + opts.toggleable).removeClass(opts.toggleselector);
            if (!isActive) {
                $(this).parent().addClass(opts.toggleselector);
            }
            if (!opts.followlink) {
                return false;
            }
        }
    });

    function setActive() {
        opts.active = true;
    }

    function setInactive() {
        opts.active = false;
    }

    function toggleActive() {
        opts.active = !opts.active;
    }

    return {
        setActive: setActive,
        setInactive: setInactive,
        toggleActive: toggleActive
    };
};

/**
 * menu for options, settings, ...
 * only one "usermenu" can be opened at the same time
 */
$.fn.usermenu = function () {
    var _window = $(window);

    $(this).each(function () {
        var _this = $(this);
        var opts = {
            divClass: 'matches'
        };
        var _openToggle = _this.find('.inner');
        var _overlay = _this.find('.' + opts.divClass);
        var id = this.id + Math.random().toString().replace(/\D/g, '');
        var _settingsClose = $('body').overlay(function () {
            _openToggle.trigger("click");
        }, { divID: id, zindex: 989 });

        _openToggle.on("click",function (e) {
            e.stopPropagation();
            e.preventDefault();

            _settingsClose.toggle();
            _overlay.toggle();
            _window.trigger('usermenu.open', { id: id });
        });

        _window.on('usermenu.open', function (e, t) {
            if ('undefined' == typeof t || (t.hasOwnProperty('id') && t.id !== id)) {
                _settingsClose.close();
                _overlay.css('display', 'none');
            }
        });
    });
};

$.fn.slideAnimator = function () {
    function getWidth(i, length) {
        return ((i + 1) / length * 100) + '%';
    }

    $(this).each(function () {
        var _this = $(this);
        var _img = _this.find('.slides').find('img').first();
        var _window = $(window);
        var slides = _this.data('slides');
        if (!slides) {
            return;
        }
        var slidesCount = slides.length;
        var currentSlide = 0;
        var interval = _this.data('interval') || 500;

        var movie = {
            running: false,
            /**
             * @private
             */
            init: function () {
                if (this.running) {
                    var self = this;

                    var viewport = { top: _window.scrollTop() };
                    viewport.bottom = viewport.top + _window.height();
                    var bounds = _this.offset();
                    bounds.bottom = bounds.top + _this.outerHeight();

                    if (viewport.bottom > bounds.top && viewport.top < bounds.bottom) {
                        setTimeout(function () {
                            $.proxy(self.nextSlide(), self);
                        }, interval);
                    } else {
                        setTimeout(function () {
                            self.init();
                        }, interval * 3);
                    }
                }
            },
            /**
             * next slide
             */
            nextSlide: function () {
                if (this.running) {
                    var self = this;
                    show(currentSlide + 1).done(function () {
                        self.init();
                    }).fail(function () {
                        setTimeout(function () {
                            show(0).done(function () {
                                self.init();
                            });
                        }, 2 * interval);
                    });
                }
            },
            /**
             * starts the slideshow
             */
            start: function () {
                if (!this.running) {
                    this.running = true;
                    this.init();
                    _play.addClass('pause');
                    _play.removeClass('play');
                }
            },
            /**
             * stops the slideshow
             */
            stop: function () {
                this.running = false;
                _play.addClass('play');
                _play.removeClass('pause');
            }
        };

        var _controls = $('<div/>').addClass('controls');
        var _statusInner = $('<div/>').addClass('status-inner').css('width', getWidth(0, slidesCount));
        var _status = $('<div/>').addClass('status-outer').append(_statusInner);
        var _play = $('<span/>').addClass('glyph play');
        var _forward = $('<span/>').addClass('glyph forward');
        var _backward = $('<span/>').addClass('glyph backward');
        var _player = $('<div/>').addClass('player');
        _player.append(_backward);
        _player.append(_play);
        _player.append(_forward);
        _controls.append(_status);
        _controls.append(_player);
        _this.append(_controls);
        _controls.css('bottom', -_player.innerHeight());


        _forward.on("click",function () {
            movie.stop();
            show(currentSlide < slidesCount - 1 ? ++currentSlide : 0);
        });
        _backward.on("click",function () {
            movie.stop();
            show(0 < currentSlide ? --currentSlide : slidesCount - 1);
        });
        _play.on("click",function () {
            if (!movie.running) {
                movie.start();
            } else {
                movie.stop();
            }
        });

        if (_this.data('autoplay')) {
            movie.start();
        }
        // TODO touch detection: if touch, treat as hover

        function show(index) {
            var deferred = new $.Deferred();

            if (index >= slidesCount) {
                deferred.reject();
            } else {
                var img = new Image();
                img.onload = function () {
                    _img.attr('src', img.src);
                    _statusInner.css('width', getWidth(index, slidesCount));
                    currentSlide = index;
                    deferred.resolve(index, img);
                };
                img.src = slides[index];
            }

            return deferred.promise();
        }
    });
};

/**
 * highly specific code for the ad/news section
 * @param _baseAd is ad that needs to be ABOVE the #fixity element
 */
// TODO: TO CAN BE REMVOED?
window.mb.fixedContent = function (_baseAd) {
    if (0 < _baseAd.length) {
        // TODO keep attributes in local scope and refresh only after resize or scroll event
        var _main = $('main');
        var _fixity = $('#fixity');
        var height = _fixity.height();
        var _window = $(window);
        var origTop = _fixity.css('top');
        var offset = _baseAd.offset();
        var changed = false;

        var scrollAd = function () {
            var y = $(this).scrollTop();

            var top = offset.top + _baseAd.height() + parseFloat(_baseAd.css('marginBottom').replace(/auto/, 0)) + 18;
            if (y >= top && height < _window.height()) {
                if (y + _fixity.height() > _main.offset().top + _main.height()) {
                    _fixity.removeClass('fix').addClass('bottom').removeAttr('style');
                }
                else {
                    _fixity.removeClass('bottom').addClass('fix').removeAttr('style').css({ left: offset.left });
                }
            } else {
                _fixity.removeClass('fix bottom').removeAttr('style').css('top', origTop);
            }
        };

        _window.resize(function () {
            changed = true;
            offset = _baseAd.offset();
        });


        _window.scroll(function () {
            changed = true;
        });

        // TODO call only after resize or scroll events
        setInterval(function () {
            if (changed) {
                changed = false;
                scrollAd();
            }
        }, 100);
    }
};

/**
 * saves current location to local storage
 * @returns {{getAll: getAll, deleteLoc: deleteLoc}}
 * @throws Error
 */
window.mb.lastvisited = function () {
    var keep = 30;
    var last = false;

    last = new localstorageManager('history');

    var stored = [];

    if (last) {
        stored = last.getItem('last');

        // add current location to the beginning of the array
        if ("undefined" !== typeof window.mb.settings.loc) {
            for (var i = 0; i < stored.length; i++) {
                var loc = stored[i];
                if (loc.iso2 == window.mb.settings.loc.iso2 && loc.id == window.mb.settings.loc.id) {
                    stored.splice(i, 1);
                }
            }
            try {
                stored.unshift(window.mb.settings.loc);
            } catch (e) {
                stored = [window.mb.settings.loc];
            }
            if (keep < stored.length) {
                stored = stored.splice(0, keep);
            }
            last.store('last', stored);
        }
    }

    let getLoc = function (locId) {
        let position = stored.map(function (x) {
            return x.id;
        }).indexOf(locId);
        return {
            loc: stored[position],
            position: position
        };
    };

    var getAll = function () {
        return stored;
    };

    // delete list entry
    var deleteLoc = function (locId) {
        let l = lang();
        let position = stored.map(function (x) {
            return x.id;
        }).indexOf(locId);
        if (Array.prototype.hasOwnProperty('map')) {
            var really = confirm(l.t("Delete {0} from the last visited list?").format(stored[position].name));
            if (really) {
                stored.splice(position, 1);
                last.store('last', stored);
                return true;
            }
        } else {
            alert(l.t('Please make sure you are using a modern browser to use all features of meteoblue.'));
        }
        return false;
    };

    return {
        // addLoc: addLoc,
        getAll: getAll,
        getLoc: getLoc,
        deleteLoc: deleteLoc
    };
};

/**
 * allows editing of fav list, syncs with db
 * @returns {{addFav: addFav, getAll: getAll, deleteFav: deleteFav}}
 * @throws exception
 */
window.mb.favourites = function () {
    var favs = null;
    var requesting = false;

    // add favourite
    var addFav = function (url, callback) {
        $.ajax({
            url: '/' + window.mb.settings.lang + '/user/favourite/create',
            data: { loc: url, token: window.mb.security.sessionToken },
            dataType: 'json',
            type: 'POST'
        }).done(function (newFav) {
            favs.push(newFav[0]);
        }).always(function (newFav) {
            if ("function" === typeof callback) {
                callback.apply(newFav[0]);
            }
        });
    };

    /**
     * delete favourite
     * @param favId favourite id
     * @param callback only executed if user confirms deletion
     */
    var deleteFav = function (favId, callback) {
        var l = lang();
        let {fav, position} = getFav(favId)
        var really = confirm(l.t('Delete {0} from the favourite list?').format(fav.name));
        if (really) {
            favs.splice(position, 1);
            var success = false;
            $.ajax({
                url: '/' + window.mb.settings.lang + '/user/favourite/delete',
                data: { id: favId, token: window.mb.security.sessionToken },
                dataType: 'json',
                type: 'POST'
            }).done(function (data) {
                favs = data;
                success = true;
            }).always(function () {
                if ("function" === typeof callback) {
                    callback.apply(success);
                }
            });
        }
    };

    var checkCurrentInFavourites = function () {
        if (window.mb.settings.hasOwnProperty('loc')) {
            var isFav = false;
            $.each(favs, function (i, fav) {
                if (fav.location_id == window.mb.settings.loc.id) {
                    isFav = true;
                }
            });
            if (!isFav) {
                $('#add_fav').removeAttr('style');
            }
        }
    };

    let moveUp = function () {

    }

    let moveDown = function () {

    }

    let getFav = function (favId) {
        let position = favs.map(function (x) {
            return x.id;
        }).indexOf(favId);
        return {
            fav: favs[position],
            position: position
        };
    }

    var getAll = function () {
        var deferred = new $.Deferred();
        if (!mb.security || "" == window.mb.security.sessionToken) {
            deferred.resolve([]);
        } else {
            if (null === favs && !requesting) {
                requesting = true;

                $.ajax({
                    url: '/' + window.mb.settings.lang + '/user/favourite/read',
                    dataType: 'json',
                    type: 'POST',
                    data: { token: window.mb.security.sessionToken }
                }).done(function (data) {
                    favs = data;
                    deferred.resolve(favs);
                }).fail(function () {
                    deferred.reject();
                }).always(function () {
                    checkCurrentInFavourites();
                    requesting = false;
                });
            } else {
                deferred.resolve(favs);
            }
        }

        return deferred.promise();
    };

    return {
        addFav: addFav,
        getAll: getAll,
        deleteFav: deleteFav,
        moveUp: moveUp,
        moveDown: moveDown,
        getFav: getFav,
    };
};

window.mb.search = window.mb.search || {};
/**
 * @param callback
 */
window.mb.search.proxy = function (callback) {
    if (window.mb.search.hasOwnProperty('wrapper')) {
        if ("function" === typeof callback) {
            callback.apply();
        }
    }
    else {
        import(/* webpackChunkName: "search" */ './modules/search').then((locationsearch) => {
            window.mb.search.search = locationsearch.search({
                lang: mb.settings.lang as string,
                showMap: true,
                favourites: mb.favourites,
                lastvisited: mb.lastvisited
            });
            window.mb.search.wrapper = locationsearch.wrapper(document.getElementById('locationform'), window.mb.search.search);

            var overlay = $('body').overlay(function () {
                window.mb.search.search.closeResults();
            }, {});

            window.mb.search.search.subscribe('locationsearch.openResults', function () {
                overlay.open();
            });

            window.mb.search.search.subscribe('locationsearch.closeResults', function () {
                overlay.close();
            });

            if ("function" === typeof callback) {
                callback.apply();
            }
        })
    }
};

window.mb.resize = function () {
    var resizeTimer;
    var mediaWidths = {
        phone: window.mb.settings.mobilewidth,
        tablet: 800,
        desktop_small: 980,
        desktop_medium: 1200,
        desktop_huge: Number.MAX_VALUE
    };
    var oldWidthName = getMediaName(window.innerWidth);

	/**
	 * get the screen category (as defined in the css file, mediaWidths must match))
	 * @param width
	 * @returns {*}
	 */
    function getMediaName(width) {
        for (var name in mediaWidths) {
            if (mediaWidths.hasOwnProperty(name)) {
                if (width <= mediaWidths[name]) {
                    return name;
                }
            }
        }
        return 'no_name';
    }

	/**
	 * compares the current screen category with the former one, sends data to Google Analytics if different
	 */
    function compare() {
        var width = window.mb.windowWidth();
        var newWidthName = getMediaName(width);
        if (newWidthName !== oldWidthName) {
            var event;
            var data = { oldWidthName: oldWidthName, newWidthName: newWidthName };
            if (window.CustomEvent) {
                event = new CustomEvent('layoutchange', { detail: data });
            } else {
                event = document.createEvent('CustomEvent');
                event.initEvent('layoutchange', true, true, data);
            }
            window.dispatchEvent(event);
            oldWidthName = newWidthName;
        }
    }

    if ('function' === typeof (window.addEventListener)) {
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                compare();
            }, 500);
        });
    }
};

/**
 * sorting options for obs data table
 * @param container
 * @returns {{load: load}}
 */
window.mb.observations = function (container) {
    var url = container.data("original");
    container.removeAttr("data-original");

    function registerEvents() {
        var header = container.find("th");
        header.click(function () {
            var params = {};

            var _this = $(this);
            if (_this.hasClass('obs_temp')) {
                params = { orderBy: 'temperature' };
            } else if (_this.hasClass('obs_time')) {
                params = { orderBy: 'time' };
            } else if (_this.hasClass('obs_dist')) {
                params = { orderBy: 'distance_km' };
            } else if (_this.hasClass('obs_asl')) {
                params = { orderBy: 'asl' };
            }

            if (_this.hasClass('asc')) {
                params.orderDir = 'DESC';
            } else {
                params.orderDir = 'ASC';
            }

            if ("undefined" !== typeof params) {
                load($.param(params));
            }
        });
    }

    function load(params) {
        var urlParams = url;
        if ("undefined" !== typeof params) {
            urlParams += '?' + params;
        }
        container.load(urlParams, function () {
            registerEvents();
        });
    }

    return {
        load: load
    };
};


// select2
function loadSelectMultiple(){
    const select2Multiple = $(".select2-multiple");
    if (select2Multiple.length > 0) {
        import(/* webpackChunkName: "select2" */ "select2/dist/js/select2.min.js").then(()=> {
            import(/* webpackChunkName: "select2_css" */ 'select2/dist/css/select2.min.css');
            select2Multiple.select2({
                width:'100%',
                placeholder: "Select or search a variable",
            });
        });
    }
}

// datepicker
function loadDateRangePickers() {
    const singleDatePickerClass = 'datepicker';
    const dateRangePickerClass = 'daterangepicker';
    const dateRangePickerElements = [ $(`.${dateRangePickerClass}`),  $(`.${singleDatePickerClass}`) ];
    const foundDateElements = dateRangePickerElements.filter(el =>  el.length > 0);
    if (foundDateElements.length > 0){
        import(/* webpackChunkName: "daterangepicker" */ "daterangepicker/daterangepicker.js").then(()=>{
            import(/* webpackChunkName: "daterangepicker_css" */ "daterangepicker/daterangepicker.css");
            for (const elements of foundDateElements){
                elements.each(function(){
                    const el = $(this);
                    const domDateRange = el.val().split(' - ');
                    const language = lang();
                    const getTranslatedAndAbbreviatedDays = function (){
                        const weekdays = [
                            'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
                        ];
                        return weekdays.map((day)=>{
                            return language.t(day).substr(0,2);
                        });
                    };

                    el.daterangepicker({
                            singleDatePicker: el.hasClass(singleDatePickerClass),
                            minDate: el.attr("startdate"),
                            maxDate: el.attr("enddate"),
                            startDate: domDateRange[0],
                            endDate:domDateRange[1],
                            showDropdowns: true,
                            autoUpdateInput: true,
                            autoApply:true,
                            drops:'auto',
                            open:'center',
                            locale: {
                                format: 'YYYY-MM-DD',
                                firstDay: language.t('Monday'),
                                monthNames:[
                                    language.t("January"),
                                    language.t("February"),
                                    language.t("March"),
                                    language.t("April"),
                                    language.t("May"),
                                    language.t("June"),
                                    language.t("July"),
                                    language.t("August"),
                                    language.t("September"),
                                    language.t("October"),
                                    language.t("November"),
                                    language.t("December"),
                                ],
                                daysOfWeek: getTranslatedAndAbbreviatedDays()
                            },
                        },
                        function(){
                            $(el.get(0).form).trigger("change");
                        }
                    );
                })
            }
        });
    }

}



// set Cookies
function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + encodeURI(value) + "; path = /; expires=" + date.toUTCString() + ";secure ";
}
// get Cookie
function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return decodeURI(y);
        }
    }
    return false;
}

// load or change position of content on scrolling
function moveScroller() {
    var checkVisibility = function () {
        if (0 < onVisibleQueue.length) {
            var scrollOffset = $(window).scrollTop() + $(window).height();
            for (var i = 0; i < onVisibleQueue.length; i++) {
                var _element = $(onVisibleQueue[i].element);
                if (scrollOffset > _element.offset().top && _element.is(':visible')) {
                    $.proxy(onVisibleQueue[i].callback, onVisibleQueue[i].element)();
                    onVisibleQueue.splice(i, 1);
                    i--;
                }
            }

            $(window).one('scroll', function () {
                setTimeout(checkVisibility, 250);
            });
        }
    };

    checkVisibility();
}


/**
 * set up
 */
$('document').ready(function () {

    // jump to day anchor on homepage on mobile phones
    /*    if (window.mb.settings.mobilewidth >= window.mb.windowWidth()) {
     // ?day=2
     var params = window.location.search.match(/\?day=([0-9]{1})/i);
     if (null !== params) {
     var h = document.getElementById('day' + parseInt(params[1], 10));
     if (!!h && h.scrollIntoView) {
     h.scrollIntoView({block: 'start', behavior: 'smooth'});
     }
     }
     }*/

    // detect svg support, add class "no_svg" to body if not
    // @link http://css-tricks.com/test-support-svg-img/
    if (!document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")) {
        $('body').addClass('no_svg');
    }

    // location search, start search for first time if user has already made an entry
    var search = $("#gls");
    if (search.length > 0) {
        if (search.val().length > 1) {
            window.mb.search.proxy(() => {
                search.focus();
            });
        }
        $('#location_search').one('click', function () {
            window.mb.search.proxy(() => {
                search.focus();
            });
            return false;
        });
    }

    // geo location
    $("#gps").on("click",function () {
        window.mb.search.proxy(function () {
            window.mb.search.wrapper.geolocate();
        });
        return false;
    });

    // dynamic loading of days for mobile devices
    $('#tab_results').on('click', '.tab a', function (e) {
        if (window.mb.settings.mobilewidth < window.mb.windowWidth() || window.mb.interstitial ) {
            return true;
        }

        e.preventDefault();

        var _this = $(this);
        var tabWrapper = $('#tab_wrapper');

        var detail = tabWrapper.find('.tab_detail[data-day=' + _this.data('day') + ']');
        _this.parent().toggleClass('active_mobile');
        detail.toggleClass('active_mobile');

        if (0 >= detail.find('.details').length) {
            detail.html('<div class="loading"></div>');
            $.ajax({
                url: _this.data('mobile')
            }).done(function (data) {
                detail.html(data);
                detail.css('height', 'auto');
            }).fail(function () {
                _this.parent().toggleClass('active_mobile');
                detail.toggleClass('active_mobile');
            });
        } else {
            detail.css('height', 'auto');
        }
        return false;
    });

    let getUrlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null){
           return null;
        }
        else {
           return decodeURI(results[1]) || 0;
        }
    }

    // open detailed day when day param. in url
    if (window.location.search !== "") {
        const day = getUrlParam("day")
        if (day !== null) {
            let tab = $('#day'+day)
            let tabDetails = tab.next()
            tab.addClass('active_mobile');
            tabDetails.addClass('active_mobile');
        }
    }

    // menu
    $(".menu_mobile_trigger").on("click", function(event){
        const navInMenu =  $('.nav').first(); // Without the collapse button
        const mobileMenu = $('#menu_mobile')

        mobileMenu.append(navInMenu);
        mobileMenu.toggleClass("active");
        $(event.target).toggleClass("active");
        $("body").overlay(()=>{
            // This callback is executed when clicking on the overlay and recursively call the click event on the menu.
            $(event.target).trigger("click");
        }, {zindex: 991}).toggle();
    });

    $('.settings').usermenu();

    // unit selector
    var _settings = $('#settings');
    _settings.on('click', 'a.unit', function (e) {
        e.stopPropagation();
        var _this = $(this);
        setCookie(_this.data('type'), _this.data('unit'), 730);
        return true;
    });

    // detect flash messages and add "close" button (they only work with JS enabled, why not generate them here...)
    var flashOuter = $('.flash_outer');
    if (0 < flashOuter.length) {
        var messages = flashOuter.find('.wrapper').find('div');
        $.each(messages, function (i, message) {
            var close = $('<span/>').addClass('glyph close');
            if (0 < messages.find('#eu-cookie').length) {
                close.on("click",function () {
                    setCookie('cookies_noticed', true, 730);
                });
            }
            close.on("click",function () {
                $(this).parent().fadeOut();
            });

            $(message).append(close);
        });
    }

    // imageanimator
    $('.slide-animator').slideAnimator();


    // charts & tools
    var bloos = $(".bloo");
    if (bloos.length > 0) {
        import(/* webpackChunkName: "bloo" */ './modules/bloo').then((bloo) => {
            new bloo.default(bloos)
        })
    }

    // trajectory
    if (0 < $('#trajectory-map').length) {
        window.mb.loadGoogleMaps().done(function () {
            import(/* webpackChunkName: "trajectory" */ './modules/trajectory').then((trajectory) => {
                const t = trajectory.default($('#trajectory-map'), $('#trajectory-form'), $('#level'), $('#trajectory-download'))
                $('#trajectory-zoom').on("click",function () {
                    t.fitContent()
                });
            });
        });
    }

    // smooth scrolling for anchors. use it by setting the class "smooth-scrolling" on the a element
    $('.smooth-scrolling').on("click", function (e) {
        e.preventDefault();
        var newPosition = $(this).attr("href");
        scrollTo($(newPosition), function () {
            if (typeof newPosition === "string") {
                location.hash = newPosition;
            }
        });
        return false;
    });

    // show/hide additional parameters on homepage
    $('.additional_parameters_toggle').on("click",function () {
        var direction = 1;
        if (getCookie('addparam')) {
            setCookie('addparam', false, -1);
            direction = 0;
        } else {
            setCookie('addparam', true, 180);
        }
        var checkbox = $('.additional_parameters');
        checkbox.prop('checked', !checkbox.prop('checked'));

        if ('function' === typeof ga) {
            var timeout = setTimeout(function () {
                window.location.reload();
            }, 200);
            ga('send', 'event', {
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: $(this).data('name'),
                eventValue: direction,
                hitCallback: function () {
                    clearTimeout(timeout);
                    window.location.reload();
                }
            });
        } else {
            window.location.reload();
        }

        return false;
    });

    // load map.js when #maps is found
    if (0 < $('#maps').length) {
        import(/* webpackChunkName: "legacymap" */ './modules/legacymap').then((legacyMap) => {
            legacyMap.default()
        })
    }

    // init window resizes
    // new window.mb.resize();

    if ('function' === typeof (window.addEventListener)) {
        window.addEventListener('layoutchange', function (e) {
            // only check here for ga because it may have been loaded later
            if ('function' === typeof ga && 'object' === typeof e.detail) {
                ga('send', 'event', 'window', 'resize', e.detail.oldWidthName + 'to' + e.detail.newWidthName);
            }
        });
    }

    // for app promotion only. track links
    var appPromo = $('a.app-promotion');
    if (0 < appPromo.length) {
        appPromo.on("click",function () {
            if ('function' === typeof ga) {
                ga('send', 'event', 'link', 'click', $(this).data('source'));
            }
        });
    }

    // load meteogram
    $(".image_lazyload").onVisible(function () {
        var _this = $(this);
        var src = _this.data('original');
        var srcset = _this.data('srcset');

        _this.on('load', function load() {
            _this.addClass('loaded').removeAttr("data-original");
            _this.css('display', '');
            _this.prev('.loading').css('display', 'none'); // hide loader, otherwise it keeps spinning behind a node
        });
        _this.on('error', function error() {
            _this.prev('.loading').css('display', 'none'); // hide loader, otherwise it keeps spinning behind a node
            _this.parent().prepend($('<div/>').text('This forecast is not available for the selected location').addClass('errorMessage'));
        });
        if (srcset) {
            _this.attr('srcset', srcset);
        }
        _this.attr('src', src);

        if (_this.data('name') && 'function' === typeof ga) {
            ga('send', 'event', 'layzload', 'load', _this.data('name'));
        }
    });

    // load tiled maps
    // feature detection for IE8 and older...
    if (document.addEventListener) {
        var jTiledMaps = $('.tiled-map');
        $.each(jTiledMaps, function (i, v) {
            $(v).onVisible(function () {

                var _this = $(this);
                import(/* webpackChunkName: "maptiles" */ './tiledmaps').then((maptiles) => {
                    maptiles.default(
                        _this.find('.tiles-grid'),
                        _this.data('source'),
                        {
                            xPos: _this.data('xpos'),
                            yPos: _this.data('ypos'),
                            utcOffset: window.mb.settings.utcOffset,
                            timezone: window.mb.settings.timezone,
                            language: window.mb.settings.lang,
                            nativeFullscreen: false
                        }
                    );
                });
            });
        });
    }

    // load leaflet map player for satellite/radar
    if (document.addEventListener) {
        var satelliteEl = $('.map-player');
        var maps = []

        $.each(satelliteEl, function (i, v) {
            $(v).onVisible(function () {

                window.mb.loadLeaflet().done(() => {
                    var mapID = $(this).data('mapid')

                    maps[`${mapID}`] = L.map(v, {
                        attributionControl: false,
                        scrollWheelZoom: false,
                        doubleClickZoom: false,
                        zoomControl: false,
                        maxBoundsViscosity: 1,
                        maxZoom: mapID === 'radar' ? 12 : 7,
                        minZoom: 2,
                    }).setView([window.mb.settings.loc.lat, window.mb.settings.loc.lon], 6)

                    var map = maps[`${mapID}`]

                    if (mapID === 'satellite') {
                        L.tileLayer(`https://maptiles.meteoblue.com/styles/overlay-${window.mb.settings.lang}/{z}/{x}/{y}{r}.png`, {
                            tileSize: 256,
                            zIndex: 999
                        }).addTo(map)
                    }

                    window.mb.loadLeafletMapPlayer().done(() => {
                        var mapPlayerDomain = $(this).data('mpdomain')
                        var outdatedMsg = $(this).data('outdatedtilesmsg')
                        var baseURL = `https://my.meteoblue.com/tiles/${mapPlayerDomain}/{timestamp}/{z}/{x}/{y}.jpg?apikey={apikey}`

                        if (mapID === 'radar') {
                            baseURL = 'https://maptiles.meteoblue.com/styles/terrain2/{z}/{x}/{y}{r}.png'
                        }

                        let layers = [{
                            name: null,
                            url: baseURL,
                            enabled: true,
                            zindex: 0,
                            options: {
                                zoomOffset: -1,
                                tileSize: 512,
                                maxNativeZoom: mapID === 'radar' ? 12 : 7,
                                detectRetina: true,
                            }
                        }]

                        // Maybe make this nicer // Maybe use contains/includes
                        if (mapPlayerDomain === 'satellite_global' || mapPlayerDomain === 'satellite_msg4'
                            || mapPlayerDomain === 'satellite_iodc' || mapPlayerDomain === 'satellite_msg3_rss'
                            || mapPlayerDomain === 'radar_us') {

                            var precipDomain = 'precipitation_global_internal'
                            if (mapPlayerDomain === 'satellite_msg3_rss') {
                                precipDomain = 'radar_eu'
                            } else if (mapPlayerDomain === 'radar_us') {
                                precipDomain = 'radar_us'
                            }

                            layers.push({
                                name: window.mb.tiledmaps.messages.precipLayer || 'Precipitation',
                                url: `https://my.meteoblue.com/tiles/${precipDomain}/{timestamp}/{z}/{x}/{y}.png?apikey={apikey}`,
                                enabled: true,
                                zindex: 1,
                                options: {
                                    zoomOffset: -1,
                                    tileSize: 512,
                                    maxNativeZoom: 6,
                                    detectRetina: true,
                                }
                            })
                        }

                        L.control.leafletMapPlayer({
                            apikey: '33d00c4b0378',
                            lat: window.mb.settings.loc.lat,
                            lon: window.mb.settings.loc.lon,
                            steps: mapID === 'radar' ? [20] : [8],
                            timezone: window.mb.settings.timezone,
                            utcOffsetInSeconds: (window.mb.settings.utcOffset * 3600),
                            animationInterval: 600,
                            timeUrl: `https://my.meteoblue.com/tiles/${mapPlayerDomain}/meteomapsTimeLast3h.json`,
                            useOutdatedMsg: true, // This could be combined with the MSG itself
                            outdatedMsg,
                            layers,
                        }).addTo(map)
                    })
                });
            });
        });
    }

    // load weather stations
    $("#surrounding_stations").onVisible(function () {
        var container = $(this).find(".surrounding_obs");
        var obs = new window.mb.observations(container);
        obs.load();
    });

    $("#print").on("click",function () {
        window.print();
    });
    $("#to-top").on("click",function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
    });

    // social
    var socialLinks = $('#share');
    if (0 < socialLinks.length) {
        // track clicks on share buttons
        socialLinks.find('a').on("click",function () {
            if ('function' === typeof ga) {
                var _this = $(this);
                ga('send', 'social', _this.data('network'), 'Share', _this.href);
            }
        })
    }

    /**
     * Adblock detection:
     * - Ad blockers prevent loads of ads.js and block all error events
     * - ghostery even replaces ``window.googletag`` with a dummy object with the same interfaces
     * - We use events on window.mb_adsloaded to detect if the ads are loaded
     * - we need to add ``onerror="window.mb_adsloaded=1" onload="window.mb_adsloaded=1"`` on the js loading script block to detect if valid ads are loaded correctly
     * - checkDfp validates that the object is valid (detects ghostery)
     * - dummyAdLoad performs a dummy XHR an detects adblock plus
     */
    var dummyAdLoad = function () {
        $.getScript(window.mb.settings.cdnServer + '/website/scripts.' + window.mb.settings.rev + '/adframe_ads.js?ad_ids=rightAds_').done(function () {
            if (window.console) {
                console.info("No ad blocking detected :-)");
            }
        }).fail(function () {
            if (window.console) {
                console.warn("Ad blocking detected :-(");
            }
            window.mb.advertising.fallback();
        })
    };
    var checkDfp = function () {
        // DFP defines a getVersion function on window.googletag which ghostery does not
        // if it is not present, a fake google js was served or no ads at all
        if (!window.googletag.hasOwnProperty('getVersion')) {
            if (window.console) {
                console.warn("DFP blocking detected :-(");
            }
            window.mb.advertising.fallback();
        } else {
            // dfp is now loaded. Perform a dummy ad loac
            dummyAdLoad();
        }
    };
    if (window.mb_adsloaded || (window.googletag && window.googletag.hasOwnProperty('display'))) {
        //console.log("google dfp script already loaded");
        checkDfp();
    } else {
        if (typeof window.mb_adsloaded === 'undefined') {
            // ads are currently loading... check later
            Object.defineProperty(window, "mb_adsloaded", { configurable: true, set: checkDfp });
        }
    }
    /* End of adblock detection */

    // init favorite table
    var _FavoriteTable = $('#favorites_table');
    if (0 < _FavoriteTable.length) {
        var jFields = _FavoriteTable.find('.inline_edit');
        jFields.inlineEdit();
    }

    // widget setup
    if (0 < $('#widget_setup').length) {
        import(/* webpackChunkName: "widgetsetup" */ './modules/widgetsetup').then((widgetsetup) => {
            widgetsetup.default();
        });
    }

    // forms with checkboxes
    var _checkboxes = $('[data-checkbox]');
    if (0 < _checkboxes.length) {
        _checkboxes.on("click",
            function () {
            var _this = $(this);
            var _others = _this.closest('form').find('[data-checkbox="' + _this.data('checkbox') + '"]').not(_this);
            _others.attr('checked', false);
        });
    }

    // expand/collapse buttons for navigation
    $('#button_collapse').on('click', navigationCollapse);
    $('#button_expand').on('click', navigationExpand);
    // status is persisted using inline JS in views/layouts/partials/navigation.volt

    // forms with data-hidefor attributes (originally from bloo.ts)
    // Disable/hide form elements as defined in data-hidefor
    $('form').on('click', applyDataHideFor);
    applyDataHideFor();

    // listeners for readmore texts
    $('[makeVisible]').on('click', onClickMakeVisible);
    $('[makeInvisible]').on('click', onClickMakeInvisible);
    // listeners for FAQ readmore boldness toggles
    $('[makeBold]').on('click', onClickMakeBold);
    $('[makeRegular]').on('click', onClickMakeRegular);

    // forms with toggleable fieldsets
    var _toggles = $('fieldset.toggle');
    if (0 < _toggles.length) {
        var _h3 = _toggles.find('h3');
        _h3.prepend($('<span/>').addClass('glyph arrowhead_hollow_down'));

        _h3.on("click",function () {
            var _this = $(this);
            var _fieldset = _this.closest('fieldset.toggle');
            var _glyph = _this.find('.glyph');
            if (_glyph.hasClass('arrowhead_hollow_down')) {
                _glyph.removeClass('arrowhead_hollow_down');
                _glyph.addClass('arrowhead_hollow_up');
                _fieldset.addClass('visible');
            } else {
                _glyph.removeClass('arrowhead_hollow_up');
                _glyph.addClass('arrowhead_hollow_down');
                _fieldset.removeClass('visible');
            }
        });
    }

    // order form
    var _orderform = $('#pointplus_order');
    if (0 < _orderform.length) {
        _orderform.change(function () {
            this.submit();
        });
    }

    // Load redactor rich text editor on demand
    if ($(".rich_text_editor").length > 0 || $(".rich_text_editor_full").length > 0) {
        var settingsFull = {
            imageUpload: '/' + window.mb.settings.lang + '/server/richtexteditor/imageupload',
            imageEditable: false,
            imageResizable: false,
            imageFigure: false,
            pastePlainText: true,
            callbacks: {
                image: {
                    uploaded: function (image, json) {
                        if (json.image.preview) {
                            image.innerHTML = `
                                <p style="float:left;margin:0 1em 1em 0;">
                                    <a rel="lightbox[article]" href="${json.image.url}">
                                        <img src="${json.image.preview}" srcset="${json.image.preview_2x} 2x">
                                    </a>
                                </p>
                            `;
                        }
                    },
                },
            },
        };

        var settings = $.extend({
            buttons: ['bold', 'italic', 'unorderedlist', 'orderedlist', 'image', 'horizontalrule']
        }, settingsFull);
        $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', window.mb.settings.cdnServer + '/website/richtexteditor/redactor.min.css'));
        $.getScript(window.mb.settings.cdnServer + "/website/richtexteditor/redactor.min.js").then(function () {
            $R('.rich_text_editor', settings);
            $R('.rich_text_editor_full', settingsFull);
        });
    }

    // toggle radar layer on satellite tiled map
    const precipsatCheck = $("#precipsat_check")
    if (precipsatCheck.length > 0) {
        precipsatCheck.on('change', function () {
            setCookie("precipsat", this.checked ? "1" : "0", 3650)
            location.reload()
        })
    }

    // inline help toggle
    const helpToggle = $("#help-toggle")
    if (helpToggle.length > 0) {
        helpToggle.on("click",() => {
            $('.inline-help').slideToggle()
            return false
        })
    }

    // history order
    if (window.mb.hasOwnProperty('history')) {
        new window.mb.history()
    }

    // scroller
    moveScroller()

    // opt out button
    const nextPreview = $('.next-preview');
    if (nextPreview.length > 0) {
        if (!isIE()) {
            nextPreview.addClass('active');
            nextPreview.on("click",function () {
                setCookie('beta', '1', 365 * 10);

                if ('function' === typeof ga) {
                    ga('send', 'event', {
                        eventCategory: 'link',
                        eventAction: 'beta',
                        eventLabel: 'optin',
                    });
                }
            });
        }
    }

    // "Copy text" feature for embedd meteogram input field
    const meteogramEmbdedInput = document.querySelector('#meteogram_src') as HTMLInputElement
    const copyButton = document.querySelector('#copy_button') as HTMLButtonElement
    if (meteogramEmbdedInput !== null && copyButton !== null) {
        addCopyTextListener(meteogramEmbdedInput, copyButton)
    }

    if ($('#extend-table-button').length > 0) {
        let btn = $('#extend-table-button')[0];
        let extRows = $('.extend-table');
        btn.onclick = function(){
            if (btn.innerHTML == "Less Metar") {
                btn.innerHTML = "More Metar"
            } else {
                btn.innerHTML = "Less Metar"
            }
            extRows.each(function() {
                $(this).toggle(400)
            });
        }
    }

    import(/* webpackChunkName: "search" */ './modules/search');
});

// forms with data-hidefor attributes (originally from bloo.ts)
// Disable/hide form elements as defined in data-hidefor
function applyDataHideFor() {
    var _form = $('form');
    // enable all elements
    _form.find('.disable').remove();
    // find elements that should be disabled
    var disableElements = _form.find('[data-hidefor]');
    disableElements.each(function () {
        var _this = $(this);
        _this.css('display', '');
        $.each(_this.data('hidefor'), function (i, vals) {
            $.each(vals, function (j, val) {
                var regExp = new RegExp('=' + encodeURIComponent(val) + '&?');
                if (_form.serialize().search(regExp) > 0) {
                    _this.css('display', 'none');
                }
            });
        });
    });
}

/**
 * Readmore visibility functions
 */
function onClickMakeVisible(e) {
    var targetid = e.currentTarget.getAttribute('makeVisible');
    console.log('triggered onClickMakeVisible: ' + targetid);
    $('[visibility="' + targetid + '"]').css('display', '');
}
function onClickMakeInvisible(e) {
    var targetid = e.currentTarget.getAttribute('makeInvisible');
    console.log('triggered onClickMakeInvisible: ' + targetid);
    $('[visibility="' + targetid + '"]').css('display', 'none');
}
/**
 * FAQ readmore boldness functions
 */
function onClickMakeBold(e) {
    var targetid = e.currentTarget.getAttribute('makeBold');
    $('[boldness="' + targetid + '"]').css('font-weight', '700');
}
function onClickMakeRegular(e) {
    var targetid = e.currentTarget.getAttribute('makeRegular');
    $('[boldness="' + targetid + '"]').css('font-weight', '400');
}

/**
 * functions for collapsing / extending navigation
 */
function navigationCollapse() {
    // add nav_collapsed to body and then add css cases for each affected item
    document.body.classList.add("nav_collapsed");

    // persist
    var navManager = new localstorageManager('navigation');
    navManager.store('collapsed', true);

    const event = document.createEvent('CustomEvent');
    event.initEvent('navigationcollapse', true, true);
    window.dispatchEvent(event)
}
function navigationExpand() {
    document.body.classList.remove("nav_collapsed");

    // persist
    var navManager = new localstorageManager('navigation');
    navManager.store('collapsed', false);

    const event = document.createEvent('CustomEvent');
    event.initEvent('navigationexpand', true, true);
    window.dispatchEvent(event)
}

/**
 * Drawer modal on the side
 */
var drawers = $(".drawer-open");
if (drawers.length > 0) {
    for (let dr = 0; dr < drawers.length; dr++) {
        var element = drawers[dr]

        const drawercontent = document.getElementById($(element).data("drawercontent"))
        const drawerwidth = $(element).data("drawerwidth")

        let overlay = $('body').overlay(function () {
            closebtn.click()
        }, { zindex: 990 });

        const drawer = document.createElement('div')
        drawer.classList.add('drawer')

        window.onclick = function(event) {
            if (event.target == drawer && drawerside.style.marginRight == "0px") {
                $(drawer).fadeOut(300)
                $(drawerside).animate({"margin-right": '-='+drawerwidth},300);
            }
        }

        const drawerside = document.createElement('div')
        drawerside.classList.add('drawer-side')
        drawerside.style.width = drawerwidth.toString()+"px"
        drawerside.style.marginRight = "-"+drawerwidth.toString()+"px"

        const closebtn = document.createElement('span')
        closebtn.innerHTML='&times;'
        closebtn.classList.add('close-drawer')
        closebtn.onclick = function(){
            $(drawer).fadeOut(300)
            $(drawerside).animate({"margin-right": '-='+drawerwidth},300);
            overlay.toggle();
        }
        drawerside.appendChild(closebtn)

        drawer.appendChild(drawerside)

        element.onclick = function(){
            $(drawer).fadeIn(300)
            $(drawerside).animate({"margin-right": '+='+drawerwidth},300);
            overlay.toggle();
        }

        drawerside.appendChild(drawercontent)
        const form = $(".bloo").find("form")[0]
        form.appendChild(drawer)
    }
}

loadDateRangePickers();
loadSelectMultiple();
